import { vservice } from '@niknevis/vue-modules'
import { StartPaymentResource } from '@/modules/transaction/models/payment.model'
import { BasePaymentlinkUseCase } from '@/modules/transaction/use-cases/shared/base-paymentlink.use-case'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { PanelWalletService } from '@/modules/wallet/services/panel-wallet.service'
import { WalletIncreaseRequest } from '@/modules/wallet/models/wallet-request.model'

@vservice()
export class WalletGetPaymentLinkUseCase extends BasePaymentlinkUseCase
  implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: PanelWalletService
  ) {
    super()
  }

  isLoading = false

  execute(data: WalletIncreaseRequest): Promise<void | StartPaymentResource> {
    this.isLoading = true
    return this.service.paymentLink(this.requestData(data)).then((res) => {
      this.isLoading = false
      return res.data
    }).catch((err) => {
      this.isLoading = false
    })
  }

  requestData(data): WalletIncreaseRequest {
    if (data.attachment) {
      const formData = new FormData()
      Object.keys(data).forEach(key => {
        formData.set(key, data[key])
      })
      data = formData as any
    }
    return data
  }

}
